/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TokenRequestDto { 
    token: string;
    tokenType?: TokenRequestDto.TokenTypeEnum;
    platform?: TokenRequestDto.PlatformEnum;
    deviceId?: string;
    appVersion?: string;
}
export namespace TokenRequestDto {
    export type TokenTypeEnum = 'mobile' | 'web';
    export const TokenTypeEnum = {
        Mobile: 'mobile' as TokenTypeEnum,
        Web: 'web' as TokenTypeEnum
    };
    export type PlatformEnum = 'ios' | 'android' | 'web';
    export const PlatformEnum = {
        Ios: 'ios' as PlatformEnum,
        Android: 'android' as PlatformEnum,
        Web: 'web' as PlatformEnum
    };
}


